import React from "react";

export default function AutoConversionControl({
  title,
  description,
  checked = false,
  disabled = false,
  onToggle,
}) {
  return (
    <div className="new-merchant-information__toggle-card">
      <div className="new-merchant-information__toggle-copy">
        <h4>{title}</h4>
        <p>{description}</p>
      </div>

      <button
        type="button"
        className={`new-merchant-information__switch ${checked ? "is-on" : ""}`}
        aria-pressed={checked}
        disabled={disabled}
        onClick={onToggle}
      >
        <span className="new-merchant-information__switch-track">
          <span className="new-merchant-information__switch-thumb" />
        </span>
        <span className="new-merchant-information__switch-label">
          {checked ? "On" : "Off"}
        </span>
      </button>
    </div>
  );
}
